export class KhasWebConstants {
  static localstorageAuthKey = "khas_web_auth"
  static localstorageTokenKey = "khas_web_token"
  static googleApiKey = "AIzaSyB42KE_SyTx0mvEWe1Z4EU9ramLWn4JBF4"
}
